import { Component, OnInit, Input } from '@angular/core';
import { BRAND, Brand, CURRENT_POLICY, USER_ID } from '@prcins/constants';
import { AccountsProviderService } from '../services/accounts-provider.service';
import { AlertPreferences } from '@prcins/utils';
import { take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'prcins-alert-preferences',
  templateUrl: './manage-alert-preferences.component.html',
  styleUrls: ['./manage-alert-preferences.component.css']
})
export class ManageAlertPreferencesComponent implements OnInit {
  policyAlerts: AlertPreferences = { emailOrPhone: null, policyBillingOption: true, claimsOption: true, newsletterOption: true };
  policyNumber: string;
  policyEmail: string;
  errorMessage: string;
  billingAlertOption: boolean;
  claimsOption: boolean;
  newsLetterOption: boolean;
  isLoading = false;
  noEmailExist = false;
  submitSuccess = false;
  submitError = false;
  fetchPolicyError = false;
  showSpinner = false;
  showSuccessMessage = false;
  showErrorMessage = false;
  showAlertSection = false;
  showTermsAndConditions = false;
  brand = localStorage.getItem(BRAND);
  mainPage = Brand[this.brand].urlEnterpriseWeb;
  constructor(private accountProvider: AccountsProviderService, private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    // this.policyNumber = sessionStorage.getItem(CURRENT_POLICY);
    let { userId } = this.route.snapshot.params;
    this.policyAlerts.emailOrPhone = userId;
    this.policyEmail = userId;
    this.billingAlertOption = false;
    this.claimsOption = false;
    this.newsLetterOption = false;
    this.isLoading = true;

    this.showSuccessMessage = false;
    this.showErrorMessage = false;

    this.accountProvider.getAlertPreferences(this.policyEmail).pipe(take(1)).subscribe(
      (policyAlerts) => {
        if (policyAlerts) {
          this.processPolicyAlertInfo(policyAlerts);
        } else {
          this.fetchPolicyError = true;
          this.isLoading = false;
          this.showTermsAndConditions = false;
          // setTimeout(() => {
          //   this.fetchPolicyError = false;
          // }, 10000);
        }
      },
      error => {
        console.log(error.message);
        this.fetchPolicyError = true;
        this.isLoading = false;
        this.showTermsAndConditions = false;
        // setTimeout(() => {
        //   this.fetchPolicyError = false;
        // }, 10000);
      }
    );

  }

  processPolicyAlertInfo(policyAlerts) {
    if (policyAlerts !== '' && policyAlerts !== undefined && policyAlerts.emailOrPhone !== null) {
      this.policyAlerts = policyAlerts;
      this.billingAlertOption = this.policyAlerts.policyBillingOption;
      this.claimsOption = this.policyAlerts.claimsOption;
      this.newsLetterOption = this.policyAlerts.newsletterOption;
      this.isLoading = false;
      this.showTermsAndConditions = true;
      this.showAlertSection = true;
    } else {
      this.isLoading = false;
      this.showTermsAndConditions = true;
      this.showAlertSection = true;
      // this.noEmailExist = true;
      this.fetchPolicyError = false;
    }

    this.billingAlertOption = this.policyAlerts.policyBillingOption;
    this.claimsOption = this.policyAlerts.claimsOption;
    this.newsLetterOption = this.policyAlerts.newsletterOption;

  }

  alertPreferenceChanged(item) {
    const { key, value } = item;

    if (key === 'billingAlertOptionKey' && value === true) {
      this.policyAlerts.policyBillingOption = true;
    } else if (key === 'billingAlertOptionKey' && value === false) {
      this.policyAlerts.policyBillingOption = false;
    }

    if (key === 'claimsOptionKey' && value === true) {
      this.policyAlerts.claimsOption = true;
    } else if (key === 'claimsOptionKey' && value === false) {
      this.policyAlerts.claimsOption = false;
    }

    if (key === 'newsletterAlertOptionKey' && value === true) {
      this.policyAlerts.newsletterOption = true;
    } else if (key === 'newsletterAlertOptionKey' && value === false) {
      this.policyAlerts.newsletterOption = false;
    }
  }

  onSaveAlertPreference() {

    const { emailOrPhone, policyBillingOption, claimsOption, newsletterOption } = this.policyAlerts;
    //alert(email+'-'+policyBillingOption+'-'+claimsOption+'-'+newsletterOption);

    let alertPreferencePayload = {
      "emailOrPhone": this.policyEmail,
      "policyBillingOption": policyBillingOption,
      "claimsOption": claimsOption,
      "newsletterOption": newsletterOption
    }

    this.accountProvider.saveAlertPreference(alertPreferencePayload).pipe(take(1)).subscribe(
      (response) => {
        this.showSpinner = false;
        if (response.communication !== null && response.communication !== '' && response.communication !== undefined) {

          this.showAlertSection = true;
          this.submitSuccess = true;
          window.scrollTo(0, 0);
          // setTimeout(() => {
          //   this.submitSuccess = false;
          // }, 10000);
        } else {
          this.submitError = true;
          // setTimeout(() => {
          //   this.submitError = false;
          // }, 10000);
        }
      },
      error => {
        this.errorMessage = error.message;
        console.log(error.message);
        this.submitError = true;
        // setTimeout(() => {
        //   this.submitError = false;
        // }, 10000);
      }
    );
  }



}
